export default __webpack_public_path__ + "static/media/buildup.9b9b5eb1.gif";